import { Dialog, DialogContent } from "@mui/material";
import { Box, Typography } from "@mui/material";
import ArgonButton from "components/ArgonButton";
import { getReportById } from "services/reportService";
import { useEffect, useState } from "react";
import CircularProgress from "@mui/material/CircularProgress";
import { REPORT_ACTIONS } from "./consts";
import { resolveReport } from "services/reportService";
import "./ReviewPanelModal.css";
import { toast } from "react-toastify";
import AvatarWithLoader from "../Avatar/AvatarWithLoader";
import { formatReasonOrContentType } from "services/utilities";

function ProfileReviewPanelModal({ open, handleClose, _id, onUpdate }) {
  const [report, setReport] = useState(null);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    setLoading(true);
    try {
      getReportById(_id).then((data) => {
        setReport(data?.data);
        setLoading(false);
      });
    } catch (error) {
      setLoading(false);
      toast.error(error.response.data.message);
    }
  }, [_id]);

  const handleAction = (action) => {
    resolveReport(_id, action).then((res) => {
      if (res.success) {
        toast.info("Action taken successfully");
        handleClose();
        onUpdate();
      } else {
        toast.error("Failed to take action");
      }
    });
  };

  return (
    <Dialog open={open} onClose={handleClose} maxWidth="md" fullWidth>
      <Box display="flex" justifyContent="center" alignItems="center" pt={3}>
        <Typography fontSize={20} fontWeight={600} color={"#344767"}>
          Profile Review Panel
        </Typography>
      </Box>
      {loading ? (
        <Box display="flex" justifyContent="center" alignItems="center" p={3}>
          <CircularProgress />
        </Box>
      ) : (
        <DialogContent sx={{ p: 4 }}>
          <Box
            display="flex"
            justifyContent="space-between"
            alignItems="center"
            mb={3}
            sx={{ flexWrap: "wrap", gap: 2 }}
          >
            <MetaItem
              label="Reported User"
              name={report?.reportedAgainst?.name}
              img={report?.reportedAgainst?.avatar}
            />
            <MetaItem
              label="Reporter"
              name={report?.reporter?.name}
              img={report?.reporter?.avatar}
            />
            <MetaItem label="Content Type" value="Profile" />
            <MetaItem
              label="Report Reason"
              value={formatReasonOrContentType(report?.reason)}
            />
          </Box>

          <Box
            display="flex"
            justifyContent="left"
            flexDirection="column"
            mt={2}
            height={250}
            width="100%"
            borderRadius={3}
            boxShadow={3}
            padding={2}
            textAlign="left"
            gap={1}
          >
            <AvatarWithLoader
              src={report?.reportedAgainst?.avatar}
              alt={report?.reportedAgainst?.name}
              width={100}
              height={100}
            />
            <Typography fontSize={16} fontWeight={700} color="#7B809A">
              {report?.reportedAgainst?.name}
            </Typography>
            <Typography fontSize={16} fontWeight={400} color="#4F4F4F">
              {report?.reportedAgainst?.bio}
            </Typography>
          </Box>

          <Box display="flex" justifyContent="center" mt={4} gap={1}>
            <ArgonButton
              className="review-panel-action-button"
              onClick={handleClose}
            >
              Cancel
            </ArgonButton>

            {!report?.isResolved && (
              <>
                {/* <ArgonButton
                  className="review-panel-action-button"
                  onClick={() => handleAction(REPORT_ACTIONS.WARN)}
                >
                  ⚠️ Warn
                </ArgonButton> */}
                {/* <ArgonButton
                  className="review-panel-action-button"
                  onClick={() => handleAction(REPORT_ACTIONS.MUTE_USER)}
                >
                  🤐 Mute User
                </ArgonButton> */}
                {/* <ArgonButton
                  className="review-panel-action-button"
                  onClick={() => handleAction(REPORT_ACTIONS.DELETE_CONTENT)}
                >
                  ❌ Delete Profile
                </ArgonButton> */}
                <ArgonButton
                  className="review-panel-action-button"
                  onClick={() => handleAction(REPORT_ACTIONS.BAN_USER)}
                >
                  ⛔ Ban User
                </ArgonButton>
                <ArgonButton
                  className="review-panel-action-button"
                  onClick={() => handleAction(REPORT_ACTIONS.DISMISS)}
                >
                  ✅ Dismiss Complain
                </ArgonButton>
              </>
            )}
          </Box>
        </DialogContent>
      )}
    </Dialog>
  );
}

function MetaItem({ label, name, value, img }) {
  return (
    <Box display="flex" flexDirection="column" alignItems="left" gap={1}>
      <Typography variant="h6" fontWeight={700} color="#000000">
        {label}
      </Typography>
      <Box display="flex" flexDirection="row" alignItems="center">
        {img && <AvatarWithLoader src={img} alt={name} />}
        <Box pb={1}>
          <Typography variant="h6" fontWeight={700} color="#7B809A">
            {name || value}
          </Typography>
        </Box>
      </Box>
    </Box>
  );
}

export default ProfileReviewPanelModal;
